export default __webpack_public_path__ + "static/alex-dube-647b3881855ab80e8c935819d7a895bc.png";